import { KNOCK_FAILED } from 'actions/Types';

export const initialState = false;

function knockFailed(state = initialState, action) {
  if (action.type === KNOCK_FAILED) {
    const newState = action.payload;
    return newState;
  }

  return state;
}

export default knockFailed;
